module.exports = __webpack_public_path__ + "img/ic_wizard_dot-active.7c4ee81f.svg";